var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1428 21.4826H12.8648M2 22L7.74207 19.7915C8.10935 19.6502 8.29298 19.5796 8.46479 19.4874C8.6174 19.4055 8.76288 19.3109 8.89972 19.2047C9.05377 19.0852 9.19289 18.9461 9.47114 18.6678L21.1428 6.99619C22.2857 5.85324 22.2857 4.00016 21.1428 2.85721C19.9998 1.71426 18.1468 1.71426 17.0038 2.85721L5.33217 14.5288C5.05392 14.8071 4.91479 14.9462 4.79525 15.1003C4.68906 15.2371 4.59452 15.3826 4.5126 15.5352C4.42038 15.707 4.34975 15.8906 4.20849 16.2579L2 22ZM2 22L4.12963 16.463C4.28202 16.0668 4.35822 15.8687 4.48891 15.7779C4.60313 15.6986 4.74445 15.6686 4.88103 15.6947C5.03732 15.7246 5.18741 15.8747 5.48759 16.1748L7.82517 18.5124C8.12535 18.8126 8.27544 18.9627 8.30528 19.119C8.33136 19.2556 8.30137 19.3969 8.22207 19.5111C8.13132 19.6418 7.93321 19.718 7.53699 19.8704L2 22Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilLine);
export default __webpack_public_path__ + "static/media/pencil-line.5ce45c925597df72170212e419dbe7a0.svg";
export { ForwardRef as ReactComponent };